import {
    ACTUALIZAR_LIST_EPP,
    AGREGAR_EPP,
  } from "./eppActions";

  const eppReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_EPP: {
            return {
                ...state,
                eppIDLista: action.payload
            }
        };

        case AGREGAR_EPP:{
            return {
                 ...state,
                 eppIDLista: [action.payload, ...state.eppIDLista]
             }
         };

        default:
            return state;

    }
  }

  export default eppReducer;
